import { Observable } from "rxjs"; 
import { url } from "./APIEndPoints";
import HttpService from "./HttpService";  
import { IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPITimeZoneModel } from "../interfaces/IAPITimeZoneModel";

class TimeZoneService {
  private httpService: HttpService;
  constructor() {
      this.httpService = new HttpService(
          undefined,
          `${process.env.REACT_APP_API_KEY}`,
          process.env.REACT_APP_API_BASE_URL,
      );
  }

  getTimeZones(): Observable<IAPIResponse<IAPITimeZoneModel[]>> {
      return this.httpService.get<IAPIResponse<IAPITimeZoneModel[]>>(url.getTimeZones);
  }
}
export default new TimeZoneService();
